import { useEffect, useState } from 'react'

export type SearchParams = {
  [key: string]: string
}

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useState<SearchParams>()

  useEffect(() => {
    const detectChanges = () => {
      const params = new URLSearchParams(window.location.search)
      const searchParams = Object.fromEntries(params.entries())
      setSearchParams(searchParams)
    }

    detectChanges()
    window.addEventListener('popstate', detectChanges)
    window.addEventListener('pushstate', detectChanges)

    return () => {
      window.removeEventListener('popstate', detectChanges)
      window.removeEventListener('pushstate', detectChanges)
    }
  }, [])

  return searchParams
}
